// 需求详情
<template>
  <div>
	<el-row type="flex" justify="center">
		<el-col :span="24">
			<el-row><el-image :src="banner"></el-image></el-row>
		</el-col>
	</el-row>
    <el-row type="flex" justify="center">
      <el-col :span="15">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-margin">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/requirement' }">需求大厅</el-breadcrumb-item>
          <el-breadcrumb-item>需求详情</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="11" class="list-container">
        <div class="card-group-top">
          <el-row type="flex" justify="space-between" align="middle" id="detail-title">
            <span class="row-align bottom-margin">
              <span class="font-big right-margin">{{requirement.name}}</span>
              <el-tag type="warning" effect="dark" size="small" v-if="requirement.status == 1">公示中</el-tag>
			  <el-tag type="danger" effect="dark" size="small" v-if="requirement.status == 2">已终止</el-tag>
            </span>
            <!--<span class="font-red font-big" v-if="requirement.settlementType == 0">-->
              <!--￥ {{requirement.amount | amountFormatter}} /单</span>-->
            <!--<span class="font-red font-big" v-else>-->
              <!--￥ {{requirement.amount | amountFormatter}} （总价）</span>-->
          </el-row>
          <el-row type="flex" justify="start" class="bottom-margin">
            <span class="font-small">
              需要坐席：{{requirement.agentDemand}}人
              <el-divider direction="vertical"/>
              剩余可申请坐席： {{requirement.agentDemandLeft}}人</span>
          </el-row>
          <el-row type="flex" justify="start" class="bottom-margin">
            <span class="font-small">
              需求类型：{{requirement.serviceTypeLabel}}
              <el-divider direction="vertical"/>
              所属行业：{{requirement.industryClassifyLabel}}</span>
          </el-row>
          <el-row type="flex" justify="start" class="bottom-margin">
            <span class="font-small">
              需求编号：{{requirement.id}}
            </span>
          </el-row>
          <el-row type="flex" justify="start" align="middle" class="bottom-margin">
            <span class="font-small font-info">更新时间：{{requirement.updateTime | dateFormatter}}</span>
            <!--            <span class="font-small font-red">（剩余7天）</span>-->
          </el-row>
          <el-row type="flex" justify="start" id="apply-btn" v-if="requirement.status == 1">
            <el-button type="primary" size="small" v-if="recordStatus == 'empty'" @click="showApplyForm">申 请</el-button>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 0">已申请</el-tag>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 1">申请已通过</el-tag>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 2">申请被驳回</el-tag>
          </el-row>
		  <el-row type="flex" justify="start" id="apply-btn" v-if="requirement.status == 2">
		    <el-tag type="danger" size="small" effect="dark">已终止</el-tag>
		  </el-row>
        </div>
        <div class="card-group-foot bottom-margin">
          <el-row type="flex" justify="start">
            <span class="font-bold bottom-margin">需求详情</span>
          </el-row>
          <el-row type="flex" justify="start">
            <div id="rtf-box" class="font-info font-small text-left" v-html="requirement.description"></div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="4" class="aside-container">
        <div class="card-group-top vertical-flex-box-center">
          <span class="font-info font-small bottom-margin">浏览次数</span>
          <span class="font-big">{{requirement.click}}</span>
        </div>
        <div class="card-group-foot vertical-flex-box bottom-margin">
          <span class="font-small bottom-margin" v-if="requirement.status == 1">此项目正在公示中</span>
		  <span class="font-small bottom-margin" v-if="requirement.status == 2">此项目已终止</span>
          <span id="apply-btn-att" v-if="requirement.status == 1">
            <el-button type="primary" size="small" v-if="recordStatus == 'empty'" @click="showApplyForm">立即申请</el-button>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 0">已申请,请耐心等待反馈</el-tag>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 1">申请已通过</el-tag>
            <el-tag type="danger" size="small" effect="dark" v-if="recordStatus == 2">申请被驳回</el-tag>
          </span>
		  <span id="apply-btn-att" v-if="requirement.status == 2">
		    <el-tag type="danger" size="small" effect="dark">已终止</el-tag>
		  </span>
        </div>
        <recommend/>
      </el-col>
    </el-row>
    <el-dialog :title="'< ' +requirement.name + ' > 申请'" :visible.sync="applyForm.visible" width="40%">
      <el-form
        :model="applyForm.formData"
        status-icon :rules="rules"
        ref="applyForm" label-width="80px">
        <el-form-item label="申请人数" prop="applyNumber">
          <el-input v-model.number="applyForm.formData.applyNumber" size="small">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
        <el-form-item label="申请描述" prop="description">
          <el-input type="textarea" v-model="applyForm.formData.description"
                    rows="4" size="small" maxlength="1000"
                    show-word-limit/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="applyForm.visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitApplyForm" :disabled="disableBtn">申 请</el-button>
      </div>
    </el-dialog>
	
	<el-dialog
	  title="您有未完成的任务培训"
	  :visible.sync="dialogVisible"
	  width="30%">
	  <el-tag style="display: block;"
	      v-for="(item, index) in abilityCertLabels2" :key="index"
	       v-show="(','+abilityCertLabelIds+',').indexOf(','+item.dictValue+',')>=0" :effect="(','+userAbilityCertLabelIds+',').indexOf(','+item.dictValue+',')>=0?'dark':'plain'">
	      <div><i class="el-icon-finished" v-if="(','+userAbilityCertLabelIds+',').indexOf(','+item.dictValue+',')>=0"></i>{{ item.dictLabel }}</div>
	    </el-tag>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="toUserCenter">去完成</el-button>
	  </span>
	</el-dialog>
  </div>
</template>

<script>
  import {
    getRequirementInfo,
    saveApplyRecord,
    checkApplyRecord,
    updateRequirementClicks,
    checkSupplierStatus,
    getApplyRecordStatus
  } from "@/api/requirement/requirement"
  import {getDictDataByType} from '@/api/common/common'
  import {mapState} from "vuex"
  import recommend from '@/components/requirement/recommend.vue'

  export default {
    data() {
      let validateApplyNumber = (rule, value, callback) => {
        if (value && value > this.requirement.agentDemandLeft) {
          callback(new Error("申请坐席数量超出需求数量"))
        } else {
          callback()
        }
      }
      return {
		banner:require("../../assets/requirement/banner_new.png"),
        requirement: {
          settlementTypeLabel: "",
          serviceTypeLabel: "",
          industryClassifyLabel: "",
          agendDemand: 0
        },
        applyForm: {
          visible: false,
          formData: {}
        },
        hasApplyed: false,
        recordStatus: "empty",
        rules: {
          applyNumber: [
            {required: true, message: "请输入申请人数", trigger: "blur"},
            {validator: validateApplyNumber, trigger: "blur"}
          ],
          description: [
            {required: true, message: "请输入申请理由", trigger: "blur"},
            {min: 5, max: 1000, message: "长度在5到1000个字符", trigger: "blur"}
          ]
        },
        disableBtn: false,
		
		userType:"00",
		dialogVisible:false,
		abilityCertLabels2:[],
		abilityCertLabelIds: "",
		userAbilityCertLabelIds: ""
      }
    },
	beforeRouteUpdate(to,from,next){
		if(to.fullPath!=from.fullPath){
			next()
			this.initPage()
		}
	},
    mounted() {
      this.initPage()
    },
    components: {
      recommend
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
        loginFlag: state => state.user.loginFlag
      })
    },
    filters: {
      amountFormatter(value) {
        if (!value) return ''
        return (value * 1).toFixed(2)
      },
      dateFormatter(value) {
        if (!value) return ''
        return (value + "").substring(0, 10)
      }
    },
    methods: {
      // 页面初始化的操作
      initPage() {
        getRequirementInfo(this.$route.params.id).then(res => {
          if (res.data.code == 0) {
            this.requirement = res.data.data
			
            // 检查登录用户是否申请过该需求
            // this.checkApplyRecord(this.requirement.id)
            this.getApplyRecordStatus(this.requirement.id)
            // 格式化字典数据
            this.formatDictData(this.requirement)
            // 更新浏览次数
            updateRequirementClicks(this.requirement.id).then((res) => {
              if (res.data.code == 0) {
                if (!this.requirement.click) {
                  this.requirement.click = 1
                } else {
                  this.requirement.click++
                }
              }
            })
          } else {
            this.$message.error("获取数据失败")
          }
        })
      },
      // 检查用户的申请记录
      checkApplyRecord(reqId) {
        // 当前浏览者登录后要检查登录用户是否申请过这个需求
        if (this.loginFlag) {
          checkApplyRecord(reqId).then(res => {
            if (res.data.code == 0) {
              this.hasApplyed = res.data.data
            } else if (res.data.code == 500 && res.data.msg == "SESSION_EXPIRED") {
              // 当前登录会话过期，清除用户信息并提示用户重新登录
              this.$store.dispatch("LogOut")
              this.$message.info("您的登录信息已过期，请重新登录")
            } else {
              this.$message.error("获取数据失败")
            }
          })
        }
      },
      getApplyRecordStatus(reqId) {
        if (this.loginFlag) {
          getApplyRecordStatus(reqId).then(res => {
            if (res.data.code == 0) {
              this.$nextTick(() => {
                this.recordStatus = res.data.data
              })
              this.$forceUpdate()
            } else if (res.data.code == 500 && res.data.msg == "SESSION_EXPIRED") {
              // 当前登录会话过期，清除用户信息并提示用户重新登录
              this.$store.dispatch("LogOut")
              this.$message.info("您的登录信息已过期，请重新登录")
            } else {
              this.$message.error("获取数据失败")
            }
          })
        }
      },
      // 格式化字典数据
      formatDictData(requirement) {
        getDictDataByType("settlement_type").then(res => {
          if (res.data.code == 0) {
            this.requirement.settlementTypeLabel = this.getDictLabelByValue(res.data.data, requirement.settlementType)
            this.$forceUpdate()
          } else {
            this.$message.error("获取数据失败")
          }
        })
        getDictDataByType("service_type").then(res => {
          if (res.data.code == 0) {
            this.requirement.serviceTypeLabel = this.getDictLabelByValue(res.data.data, requirement.serviceType)
            this.$forceUpdate()
          } else {
            this.$message.error("获取数据失败")
          }
        })
        getDictDataByType("industry_classify").then(res => {
          if (res.data.code == 0) {
            this.requirement.industryClassifyLabel = this.getDictLabelByValue(res.data.data, requirement.industryClassify)
            this.$forceUpdate()
          } else {
            this.$message.error("获取数据失败")
          }
        })
		getDictDataByType("ability_cert_label").then(res => {
		  if (res.data.code == 0) {
		    this.abilityCertLabels2 = res.data.data;
		    this.$forceUpdate()
		  } else {
		    this.$message.error("获取数据失败")
		  }
		})
      },
      // 根据字典值获取字典标签
      getDictLabelByValue(dictDataList, dictValue) {
        let dictLabel = ""
        dictDataList.some(dictData => {
          if (dictData.dictValue == dictValue) {
            dictLabel = dictData.dictLabel
            return true
          }
        })
        return dictLabel
      },
      showApplyForm() {
        if (!this.loginFlag) {
          this.$message.info("请先登录系统")
        } else {
			
          checkSupplierStatus().then(res => {
            if (res.data.code == 0) {
				this.userType = res.data.msg;
				if(this.userType == '01'){
					this.applyForm.formData.applyNumber = 1;
					return this.submitApplyForm2();
				}
              this.applyForm.visible = true
            } else if (res.data.code == 500 && res.data.msg == "SESSION_EXPIRED") {
              // 当前登录会话过期，清除用户信息并提示用户重新登录
              this.$store.dispatch("LogOut")
              this.$message.info("您的登录信息已过期，请重新登录")
            } else if (res.data.code == 500 && res.data.msg == "INCORRECT_STATUS") {
              // 当前登录用户未通过审核
              this.$message.info("请先等待账户通过审核")
            } else {
              this.$message.error("获取数据失败")
            }
          })
        }
      },
      submitApplyForm() {
        let _this = this
        this.$refs['applyForm'].validate((valid) => {
          if (valid) {
            // 增加申请人数的验证规则
            // if (_this.applyForm.formData.applyNumber * 1 > _this.requirement.agentDemand * 1) {
            //   _this.$message.error("申请人数不应超过坐席需求数量")
            //   _this.applyForm.formData.applyNumber = ""
            //   return false
            // }
            this.submitApplyForm2();
          } else {
            // 表单验证失败
            return false
          }
        })
      },
	submitApplyForm2(){
		this.applyForm.formData.requirementId = this.requirement.id
		this.disableBtn = true
		saveApplyRecord(this.applyForm.formData).then(res => {
			if (res.data.code == 0) {
				this.$message.success("申请成功，请耐心等待反馈")
				this.applyForm.visible = false
				this.recordStatus = 0
			} else if (res.data.code == 500 && res.data.msg == "SESSION_EXPIRED") {
			// 当前登录会话过期，清除用户信息并提示用户重新登录
				this.$store.dispatch("LogOut")
				this.$message.info("您的登录信息已过期，请重新登录")
			}else if(res.data.code == 500 && (res.data.msg).indexOf('CERT_VALID')>=0){
				
				let certData = (res.data.msg).split('-');
				this.abilityCertLabelIds = certData[1];
				this.userAbilityCertLabelIds = certData[2];
				this.dialogVisible = true;
			}else if(res.data.code == 500 && res.data.msg == "NUMBER_VALID"){
				this.$message.info("申请人数不应超过坐席需求数量")
			} else {
				this.$message.error("数据保存失败")
			}
			this.disableBtn = false
		})
	},
	// 跳转到企业中心
	toUserCenter() {
		this.dialogVisible = false;
		window.open("https://admin.kefubang.com", '_blank')
	}
    }
  }
</script>

<style scoped>
  @import "../../assets/css/common.css";

  .breadcrumb-margin {
    margin: 1px;
    padding: 10px 0;
  }

  .aside-container {
    padding-left: 10px;
  }

  .list-item-title span {
    font-size: 16px;
  }

  .ul-no-dot li {
    list-style: none;
    padding-bottom: 5px;
    text-align: left;
  }

  #detail-title {
    margin: 20px 0;
  }

  .row-align {
    display: flex;
    align-items: center;
  }

  #apply-btn button {
    margin: 20px 0;
    width: 100px;
  }

  #apply-btn-att {
    width: 100%;
  }

  #apply-btn-att button {
    width: 100%;
  }

  #apply-btn-att span {
    width: 100%;
  }

  #rtf-box {
    width: 100%;
  }

  #rtf-box table {
    width: 100%;
  }
</style>
